/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import { Scroller as tt, SearchService as ot, scrollToPage as F, removeChildren as L, loadPDF as me, reloadDocument as nt, goToNextSearchMatch as de, goToPreviousSearchMatch as at, currentPage as rt, calculateZoomLevel as lt, download as ct, print as st, DEFAULT_ZOOM_LEVEL as it } from "@progress/kendo-pdfviewer-common";
import { currentPage as Yt } from "@progress/kendo-pdfviewer-common";
import * as e from "react";
import l from "prop-types";
import { ButtonGroup as ge, Button as m, Toolbar as ut, ToolbarSpacer as mt } from "@progress/kendo-react-buttons";
import { TextBox as dt, InputSuffix as gt } from "@progress/kendo-react-inputs";
import { Pager as ft } from "@progress/kendo-react-data-tools";
import { Upload as vt } from "@progress/kendo-react-upload";
import { ComboBox as ht } from "@progress/kendo-react-dropdowns";
import { Loader as kt } from "@progress/kendo-react-indicators";
import { validatePackage as pt, shouldShowValidationUI as bt, classNames as yt, WatermarkOverlay as Et } from "@progress/kendo-react-common";
import { useLocalization as wt } from "@progress/kendo-react-intl";
import { zoomOutIcon as Ct, zoomInIcon as St, pointerIcon as xt, handIcon as Zt, searchIcon as Pt, folderOpenIcon as zt, downloadIcon as Lt, printIcon as Tt, convertLowercaseIcon as It, arrowUpIcon as Nt, arrowDownIcon as Mt, xIcon as Rt } from "@progress/kendo-svg-icons";
import "pdfjs-dist/build/pdf.worker.entry.js";
const fe = {
  name: "@progress/kendo-react-pdf-viewer",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702645178,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, B = "pdfviewer.zoomIn", A = "pdfviewer.zoomOut", K = "pdfviewer.enableSelection", U = "pdfviewer.enablePanning", w = "pdfviewer.search", W = "pdfviewer.open", V = "pdfviewer.download", _ = "pdfviewer.print", $ = "pdfviewer.close", j = "pdfviewer.matchCase", q = "pdfviewer.prevMatch", H = "pdfviewer.nextMatch", he = "pdfviewer.actualWidth", ke = "pdfviewer.fitToWidth", pe = "pdfviewer.fitToPage", G = "pdfviewer.popupBlocked", i = {
  [B]: "Zoom in",
  [A]: "Zoom out",
  [K]: "Enable selection",
  [U]: "Enable panning",
  [w]: "Search",
  [W]: "Open",
  [V]: "Download",
  [_]: "Print",
  [$]: "Close",
  [j]: "Match case",
  [q]: "Previous match",
  [H]: "Next match",
  [he]: "Actual width",
  [ke]: "Fit to width",
  [pe]: "Fit to page",
  [G]: "Popup is blocked."
}, be = [
  "pager",
  "spacer",
  "zoomInOut",
  "zoom",
  "selection",
  "spacer",
  "search",
  "open",
  "download",
  "print"
], p = {
  minZoom: 0.5,
  maxZoom: 4,
  tools: [...be],
  zoomRate: 0.25,
  zoomLevels: [
    { id: 1, priority: 1, value: 1, text: "Actual width", type: "ActualWidth", locationString: he },
    { id: 2, priority: 2, value: 1, text: "Fit to width", type: "FitToWidth", locationString: ke },
    { id: 3, priority: 3, value: 1, text: "Fit to page", type: "FitToPage", locationString: pe },
    { id: 4, priority: 4, value: 0.5, text: "50%", type: "" },
    { id: 5, priority: 5, value: 0.75, text: "75%", type: "" },
    { id: 6, priority: 100, value: 1, text: "100%", type: "" },
    { id: 7, priority: 7, value: 1.25, text: "125%", type: "" },
    { id: 8, priority: 8, value: 1.5, text: "150%", type: "" },
    { id: 9, priority: 9, value: 2, text: "200%", type: "" },
    { id: 10, priority: 10, value: 3, text: "300%", type: "" },
    { id: 11, priority: 11, value: 4, text: "400%", type: "" }
  ],
  defaultZoom: it
}, Dt = [
  ".k-toolbar > button",
  ".k-toolbar .k-combobox > input",
  ".k-toolbar .k-button-group > button",
  ".k-toolbar .k-pager > a",
  ".k-toolbar .k-pager input"
];
let ve = 0;
function Ot() {
  return ve++, ve;
}
const Ft = (n, C) => n.priority > C.priority ? -1 : n.priority < C.priority ? 1 : 0, J = e.forwardRef((n, C) => {
  pt(fe);
  const ye = bt(fe), {
    zoom: Q,
    zoomLevels: X = p.zoomLevels,
    defaultZoom: T = p.defaultZoom,
    minZoom: I = p.minZoom,
    maxZoom: N = p.maxZoom,
    zoomRate: S = p.zoomRate
  } = n, s = wt(), c = e.useRef(null), [Ee, x] = e.useState(T), d = Q !== void 0 ? Q : Ee, E = X.slice().sort(Ft).find((o) => o.value === d) || { text: d * 100 + "%", value: d, id: d, locationString: "" };
  E.locationString && (E.text = s.toLanguageString(E.locationString, i[E.locationString]));
  const [g, M] = e.useState(!1), [we, h] = e.useState(!0), [Z, Y] = e.useState(0), [P, ee] = e.useState(!1), [Ce, te] = e.useState(!1), [k, R] = e.useState(0), [f, b] = e.useState(0), [y, oe] = e.useState(!1), [D, ne] = e.useState(""), t = e.useMemo(() => ({}), []);
  t.currentZoom = d, t.props = n;
  const ae = e.useCallback((o) => {
    c.current && c.current.style.setProperty("--scale-factor", String(o));
  }, []), v = e.useRef(null), z = e.useRef(null);
  e.useImperativeHandle(v, () => ({
    get element() {
      return z.current;
    },
    props: n,
    get pages() {
      return t.pages;
    },
    get document() {
      return t.document;
    }
  }), []), e.useImperativeHandle(C, () => v.current);
  const Se = e.useCallback(() => {
    if (t.props.onLoad) {
      const o = { target: v.current };
      t.props.onLoad.call(void 0, o);
    }
  }, []), re = e.useCallback((o, a, r) => {
    if (n.onDownload) {
      const u = {
        target: v.current,
        blob: o,
        fileName: a,
        saveOptions: r
      };
      return n.onDownload.call(void 0, u) === !1;
    }
    return !1;
  }, [n.onDownload]), xe = e.useCallback(() => {
    var o;
    t.scroller && t.scroller.destroy(), t.scroller = new tt((o = c.current) == null ? void 0 : o.parentNode, {
      filter: ".k-page",
      events: {}
    }), t.scroller.enablePanEventsTracking();
  }, []), Ze = e.useCallback((o) => {
    const a = Array.from(o.querySelectorAll(".k-text-layer"));
    t.search = new ot({
      textContainers: a || [],
      highlightClass: "k-search-highlight",
      highlightMarkClass: "k-search-highlight-mark",
      charClass: "k-text-char"
    });
  }, []);
  t.done = e.useCallback(({ pdfPages: o, pdfDoc: a, zoom: r }) => {
    t.document = a, t.pages = o, t.zoom = r, xe(), h(!1), M(!0), Se(), c.current && F(c.current, 0);
  }, []), t.error = e.useCallback((o) => {
    if (t.document = null, t.pages = [], h(!1), M(!1), n.onError) {
      const a = {
        error: typeof o == "string" ? { message: o } : o,
        target: v.current
      };
      n.onError.call(void 0, a);
    }
  }, [n.onError]), e.useEffect(() => {
    c.current && (n.url || n.data || n.arrayBuffer ? (h(!0), L(c.current), me({
      url: n.url,
      data: n.data,
      arrayBuffer: n.arrayBuffer,
      dom: c.current,
      zoom: t.currentZoom,
      done: t.done,
      error: t.error
    }), ae(t.currentZoom)) : (t.document = null, t.pages = [], M(!1), h(!1), L(c.current)));
  }, [n.url, n.data, n.arrayBuffer]);
  const le = e.useCallback((o, a) => {
    c.current && (h(!0), L(c.current), nt({
      pdfDoc: o,
      zoom: a,
      dom: c.current,
      done: (r) => {
        t.pages = r, t.zoom = a, h(!1);
      },
      error: t.error
    }));
  }, []);
  e.useEffect(() => {
    ae(d), c.current && t.document && d !== t.zoom && le(t.document, d);
  }, [d, le]), e.useEffect(() => () => {
    t.scroller && t.scroller.destroy(), t.search && t.search.destroy(), t.document = null, t.pages = [];
  }, []);
  const Pe = e.useCallback(() => {
    te(!0), Ze(c.current);
  }, []), ze = e.useCallback((o) => {
    const a = o.value, r = t.search.search({ text: a, matchCase: y });
    b(r.length ? 1 : 0), R(r.length), ne(a);
  }, [y]), Le = e.useCallback(() => {
    const o = t.search.search({ text: D, matchCase: !y });
    b(o.length ? 1 : 0), R(o.length), oe(!y);
  }, [y, D]), Te = e.useCallback(() => {
    de(t), b(f + 1 > k ? 1 : f + 1);
  }, [f, k]), Ie = e.useCallback(() => {
    at(t), b(f - 1 < 1 ? k : f - 1);
  }, [f, k]), ce = e.useCallback(() => {
    t.search.destroy(), b(0), R(0), oe(!1), ne(""), te(!1);
  }, []), Ne = e.useCallback((o) => {
    o.key === "Enter" ? (o.preventDefault(), de(t), b(f + 1 > k ? 1 : f + 1)) : o.key === "Escape" && ce();
  }, [f, k]), Me = e.useCallback((o) => {
    if (c.current) {
      const a = o.skip;
      F(c.current, a);
      const r = {
        page: a + 1,
        target: v.current,
        syntheticEvent: o.syntheticEvent
      };
      n.onPageChange && n.onPageChange.call(void 0, r);
    }
    Y(o.skip);
  }, [Z, n.onPageChange]), Re = e.useCallback((o) => {
    if (z.current) {
      const a = rt(z.current);
      if (a !== Z) {
        Y(a);
        const r = {
          page: a + 1,
          target: v.current,
          syntheticEvent: o
        };
        n.onPageChange && n.onPageChange.call(void 0, r);
      }
    }
  }, [Z, n.onPageChange]), De = e.useCallback((o) => {
    const a = Math.min(t.currentZoom + S, N);
    if (a !== t.currentZoom && t.document && (x(a), n.onZoom)) {
      const r = {
        zoom: a,
        target: v.current,
        syntheticEvent: o
      };
      n.onZoom.call(void 0, r);
    }
  }, [S, N, n.onZoom]), Oe = e.useCallback((o) => {
    const a = Math.max(t.currentZoom - S, I);
    if (a !== t.currentZoom && t.document && (x(a), n.onZoom)) {
      const r = {
        zoom: a,
        target: v.current,
        syntheticEvent: o
      };
      n.onZoom.call(void 0, r);
    }
  }, [S, I, n.onZoom]), Fe = e.useCallback((o) => {
    const a = o.value === null ? { text: "100%", value: 1, id: 100 } : { ...o.value };
    if (a.value === void 0) {
      const u = parseFloat(a.text);
      typeof u == "number" && !Number.isNaN(u) ? a.value = u / 100 : a.value = 1;
    }
    let r = a ? lt(a.value, a.type, t.currentZoom, c.current) : 1;
    if (r = Math.round(r * 100) / 100, t.currentZoom !== r && t.document && (x(r), n.onZoom)) {
      const u = {
        zoom: r,
        target: v.current,
        syntheticEvent: o.syntheticEvent
      };
      n.onZoom.call(void 0, u);
    }
  }, [n.onZoom]), Be = e.useCallback(() => {
    t.scroller.disablePanEventsTracking(), ee(!0);
  }, []), Ae = e.useCallback(() => {
    t.scroller.enablePanEventsTracking(), ee(!1);
  }, []), Ke = e.useCallback(() => {
    ct({
      pdf: t.document,
      error: t.error
    }, n.saveFileName, n.saveOptions, re);
  }, [n.url, n.data, n.arrayBuffer, n.saveFileName, n.saveOptions, re]), Ue = e.useCallback(() => {
    h(!0);
    const o = (r) => {
      t.error(typeof (r ? r.message || r : null) == "string" ? r.message || r : s.toLanguageString(G, i[G]));
    }, a = () => {
      h(!1);
    };
    st(t.pages, a, o);
  }, []), We = e.useCallback((o) => {
    const a = o.newState;
    a[0] && a[0].getRawFile && a[0].getRawFile().arrayBuffer().then((u) => {
      if (c.current) {
        h(!0), L(c.current);
        const O = t.props.zoom === void 0 ? T : t.props.zoom;
        me({
          arrayBuffer: u,
          dom: c.current,
          zoom: O,
          done: t.done,
          error: t.error
        }), x(O);
      }
    });
  }, [T]), Ve = e.useCallback((o) => {
    const a = o.target;
    if (a instanceof Element && a.parentNode) {
      const r = a.closest(".k-toolbar"), u = r && r.querySelector(".k-upload input");
      u && u.click();
    }
  }, []), se = we && /* @__PURE__ */ e.createElement("div", { className: "k-loader-container k-loader-container-md k-loader-top" }, /* @__PURE__ */ e.createElement("div", { className: "k-loader-container-overlay k-overlay-light" }), /* @__PURE__ */ e.createElement("div", { className: "k-loader-container-inner " }, /* @__PURE__ */ e.createElement(kt, { size: "large" }))), _e = /* @__PURE__ */ e.createElement(ge, null, /* @__PURE__ */ e.createElement(
    m,
    {
      className: "k-toolbar-button",
      title: s.toLanguageString(A, i[A]),
      disabled: d <= I || !g,
      onClick: Oe,
      icon: "zoom-out",
      svgIcon: Ct
    }
  ), /* @__PURE__ */ e.createElement(
    m,
    {
      className: "k-toolbar-button",
      title: s.toLanguageString(B, i[B]),
      disabled: d >= N || !g,
      onClick: De,
      icon: "zoom-in",
      svgIcon: St
    }
  )), $e = /* @__PURE__ */ e.createElement(
    ht,
    {
      disabled: !g,
      data: X.map(
        (o) => ({
          ...o,
          text: o.locationString ? s.toLanguageString(o.locationString, i[o.locationString]) : o.text
        })
      ),
      dataItemKey: "id",
      textField: "text",
      value: g ? E : null,
      allowCustom: !0,
      onChange: Fe
    }
  ), je = /* @__PURE__ */ e.createElement(
    ft,
    {
      previousNext: !0,
      type: "input",
      skip: Z,
      take: 1,
      total: t.pages ? t.pages.length : 0,
      info: !1,
      onPageChange: Me
    }
  ), qe = /* @__PURE__ */ e.createElement(mt, null), He = /* @__PURE__ */ e.createElement(ge, null, /* @__PURE__ */ e.createElement(
    m,
    {
      className: "k-toolbar-button",
      title: s.toLanguageString(K, i[K]),
      icon: "pointer",
      svgIcon: xt,
      disabled: !g,
      togglable: !0,
      selected: P && g,
      onClick: Be
    }
  ), /* @__PURE__ */ e.createElement(
    m,
    {
      className: "k-toolbar-button",
      title: s.toLanguageString(U, i[U]),
      icon: "hand",
      svgIcon: Zt,
      disabled: !g,
      togglable: !0,
      selected: !P && g,
      onClick: Ae
    }
  )), Ge = /* @__PURE__ */ e.createElement(
    m,
    {
      className: "k-toolbar-button",
      title: s.toLanguageString(w, i[w]),
      icon: "search",
      svgIcon: Pt,
      disabled: !g,
      onClick: Pe
    }
  ), Je = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    m,
    {
      className: "k-toolbar-button",
      title: s.toLanguageString(W, i[W]),
      icon: "folder-open",
      svgIcon: zt,
      onClick: Ve
    }
  ), /* @__PURE__ */ e.createElement("div", { style: { display: "none" } }, /* @__PURE__ */ e.createElement(
    vt,
    {
      restrictions: { allowedExtensions: [".pdf"] },
      onAdd: We,
      autoUpload: !1,
      defaultFiles: [],
      multiple: !1,
      accept: ".pdf,.PDF",
      withCredentials: !1
    }
  ))), Qe = /* @__PURE__ */ e.createElement(
    m,
    {
      className: "k-toolbar-button",
      title: s.toLanguageString(V, i[V]),
      icon: "download",
      svgIcon: Lt,
      disabled: !g,
      onClick: Ke
    }
  ), Xe = /* @__PURE__ */ e.createElement(
    m,
    {
      className: "k-toolbar-button",
      title: s.toLanguageString(_, i[_]),
      icon: "print",
      svgIcon: Tt,
      disabled: !g,
      onClick: Ue
    }
  ), Ye = {
    pager: je,
    spacer: qe,
    zoomInOut: _e,
    zoom: $e,
    selection: He,
    search: Ge,
    open: Je,
    download: Qe,
    print: Xe
  }, et = (n.tools || p.tools).map((o) => ({ ...Ye[o], key: "toobar-tool-" + o + Ot() })), ie = /* @__PURE__ */ e.createElement(ut, { buttons: Dt }, ...et), ue = /* @__PURE__ */ e.createElement(
    "div",
    {
      className: yt("k-canvas k-pdf-viewer-canvas k-pos-relative k-overflow-auto", {
        "k-enable-text-select": P,
        "k-enable-panning": !P
      }),
      onScroll: Re
    },
    Ce && /* @__PURE__ */ e.createElement("div", { className: "k-search-panel k-pos-sticky k-top-center" }, /* @__PURE__ */ e.createElement(
      dt,
      {
        value: D,
        onChange: ze,
        placeholder: s.toLanguageString(w, i[w]),
        autoFocus: !0,
        onKeyDown: Ne,
        suffix: () => /* @__PURE__ */ e.createElement(gt, null, /* @__PURE__ */ e.createElement(
          m,
          {
            icon: "convert-lowercase",
            svgIcon: It,
            title: s.toLanguageString(j, i[j]),
            fillMode: "flat",
            togglable: !0,
            selected: y,
            onClick: Le
          }
        ))
      }
    ), /* @__PURE__ */ e.createElement("span", { className: "k-search-matches" }, /* @__PURE__ */ e.createElement("span", null, f), " of ", /* @__PURE__ */ e.createElement("span", null, k)), /* @__PURE__ */ e.createElement(
      m,
      {
        title: s.toLanguageString(q, i[q]),
        fillMode: "flat",
        icon: "arrow-up",
        svgIcon: Nt,
        disabled: k === 0,
        onClick: Ie
      }
    ), /* @__PURE__ */ e.createElement(
      m,
      {
        title: s.toLanguageString(H, i[H]),
        fillMode: "flat",
        icon: "arrow-down",
        svgIcon: Mt,
        disabled: k === 0,
        onClick: Te
      }
    ), /* @__PURE__ */ e.createElement(
      m,
      {
        title: s.toLanguageString($, i[$]),
        fillMode: "flat",
        icon: "x",
        svgIcon: Rt,
        onClick: ce
      }
    )),
    /* @__PURE__ */ e.createElement("div", { ref: c, className: "k-pdf-viewer-pages" })
  );
  return /* @__PURE__ */ e.createElement("div", { className: "k-pdf-viewer", style: n.style, ref: z }, n.onRenderLoader ? n.onRenderLoader.call(void 0, se || null) : se, n.onRenderToolbar ? n.onRenderToolbar.call(void 0, ie) : ie, n.onRenderContent ? n.onRenderContent.call(void 0, ue) : ue, ye && /* @__PURE__ */ e.createElement(Et, null));
});
J.displayName = "KendoReactPDFViewer";
J.propTypes = {
  url: l.string,
  data: l.string,
  arrayBuffer: l.any,
  typedArray: l.any,
  style: l.object,
  saveFileName: l.string,
  saveOptions: l.object,
  tools: l.arrayOf(l.oneOf(be).isRequired),
  zoomLevels: l.arrayOf(l.any),
  zoom: l.number,
  defaultZoom: l.number,
  minZoom: l.number,
  maxZoom: l.number,
  zoomRate: l.number,
  onError: l.func,
  onLoad: l.func,
  onDownload: l.func,
  onRenderToolbar: l.func,
  onRenderContent: l.func,
  onRenderLoader: l.func,
  onZoom: l.func
};
J.defaultProps = p;
const Jt = F;
export {
  J as PDFViewer,
  Yt as currentPage,
  Jt as scrollToPage
};
